// TODO: adjust image sizes according to the real grid width
export const IMG_SIZES = [
    '(min-width: 1536px) 1530px',
    '(min-width: 1140px) 89.1vw',
    '(min-width: 900px) 96.7vw',
    '(min-width: 600px) 96.7vw',
    '51.4vw',
].join(',');
